import { ResponseError } from 'shared/common/errors/responseError';
import { IApplicationContext } from 'shared/common/types/applicationContext';
import { TFetchFormParams } from 'shared/common/types/form';

export async function fetchCallbackForm(
  { httpApi, logger }: IApplicationContext,
  params: TFetchFormParams,
): Promise<string> {
  try {
    const { statusCode, response } = (await httpApi.fetch(
      {
        apiType: 'external',
        microserviceName: 'my-external-api',
        assertStatusCodes: [200, 400, 500],
        method: 'POST',
        pathApi: '/api/franchise/v1/save-form-request',
        parameters: params,
      },
      {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
    )) as { statusCode: number; response: string };

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'info',
        message: String(response),
      });
    }

    return response;
  } catch (ex) {
    logger.error(ex as Error);

    throw ex;
  }
}
